__turbopack_context__.v({
  "schedule": "ScheduleAndPrice-module-sass-module__GqM7wq__schedule",
});
